"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitialData = void 0;
const getInitialData = () => {
    return window === null || window === void 0 ? void 0 : window.__INITIAL__DATA__;
};
exports.getInitialData = getInitialData;
